import { useContext } from 'react';
import { TenantsContext } from './tenantsContext';

export const useTenants = () => {
  const context = useContext(TenantsContext);
  if (context === undefined) {
    throw new Error('useTenants must be used within a TenantsProvider');
  }
  return context;
};
